import React, { useState } from 'react';
import { components } from 'react-select';
import { Delete, Edit, StarBorder, EmojiEmotions } from '@material-ui/icons';

export default function PresetSelectOption({ onDelete, onEdit, isITStaff, isDefault, editAvailable, getStyles, Icon, isDisabled, isFocused, isSelected, children, innerProps, ...props }) {
  const presetId = props.data.value;
	const isNew = props.data.__isNew__;
  const presetOption = props.data;

  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = "transparent";
  if (isFocused) bg = "#eee";
  if (isActive) bg = "#B2D4FF";

  const style = {
    alignItems: "center",
    backgroundColor: bg,
    color: isDisabled? 'lightgrey' : "inherit",
    display: "flex",
  };

  // prop assignment
  const _innerProps = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style
  };

  const defaultPresetStyle = {
    fontSize: '2em',
    borderRadius: '100%',
    color: '#bbb',
    zoom: '1.3',
    marginLeft: '-3',
    marginRight: '3'
  };

  const customPresetStyle = {
    fontSize: '2em',
    marginLeft: '0',
    marginRight: '8px',
    borderRadius: '100%',
    color: '#fff',
    backgroundColor: 'd5c9c9'
  }

	const editStyle = {
		color: 'hsl(0deg 0% 46%)',
    fontSize: '2em',
    marginLeft: 'auto',
    cursor: 'pointer',
    background: 'hsl(0deg 0% 86%)',
    borderRadius: '100%',
    padding: '3.6px',
	}

	const deleteStyle = {
		color: '#ff3131',
    fontSize: '2em',
    marginLeft: '0.4em',
    cursor: 'pointer',
    background: '#f2c6c6',
    borderRadius: '100%',
    padding: '3.6px',
	}

	const handleEdit = e => {
		e.stopPropagation();
		onEdit(presetOption);
	}

	const handleDelete = e => {
		e.stopPropagation();
		onDelete(presetId);
	}

	return (
    <components.Option {...props} isDisabled={isDisabled} isFocused={isFocused} isSelected={isSelected} getStyles={getStyles} innerProps={_innerProps}>
      {isITStaff &&
        (isDefault ? <StarBorder style={defaultPresetStyle} /> : <EmojiEmotions style={customPresetStyle} />)
      }
      {children}
			{(!isNew && editAvailable) && <>
				<Edit style={editStyle} onClick={handleEdit} />
				<Delete style={deleteStyle} onClick={handleDelete} />
			</>}
    </components.Option>
  );
};